(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["be-article"]) return;
  try {
    
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-bea-copy]');
  if (!btn || !navigator.clipboard) return;
  navigator.clipboard.writeText(btn.getAttribute('data-bea-copy')).then(function () {
    btn.classList.add('is-copied');
    setTimeout(function () { btn.classList.remove('is-copied'); }, 2000);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["be-collection"]) return;
  try {
    
window.becQuickAdd = async function(e, variantId, btn) {
  e.preventDefault();
  e.stopPropagation();
  const orig = btn.innerHTML;
  btn.disabled = true;
  btn.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="animation:bec-spin .6s linear infinite"><line x1="12" y1="2" x2="12" y2="6"/><line x1="12" y1="18" x2="12" y2="22"/><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"/><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"/><line x1="2" y1="12" x2="6" y2="12"/><line x1="18" y1="12" x2="22" y2="12"/><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"/><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"/></svg>';
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    if (!res.ok) throw await res.json();
    btn.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg> Toegevoegd!';
    btn.style.background = 'var(--be-green-mid)';
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  } catch(err) {
    btn.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg> ' + ((err && err.description) || 'Probeer opnieuw');
    btn.style.background = '#b91c1c';
  }
  setTimeout(function() {
    btn.innerHTML = orig;
    btn.style.background = '';
    btn.disabled = false;
  }, 2200);
};

/* Spinner keyframe */
(function() {
  if (document.getElementById('bec-spin-style')) return;
  var s = document.createElement('style');
  s.id = 'bec-spin-style';
  s.textContent = '@keyframes bec-spin { to { transform: rotate(360deg); } }';
  document.head.appendChild(s);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["be-header"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  // ── ANNOUNCEMENT ROTATION ──────────────────────────────────────────────
  var msgs = document.querySelectorAll('.be-topbar-msg');
  if (msgs.length > 1) {
    var cur = 0;
    setInterval(function() {
      msgs[cur].classList.remove('active');
      cur = (cur + 1) % msgs.length;
      msgs[cur].classList.add('active');
    }, 4000);
  }

  // ── STICKY HEADER ─────────────────────────────────────────────────────
  var header = document.getElementById('be-site-header');
  var topbar = document.getElementById('be-topbar');
  if (header && topbar) {
    window.addEventListener('scroll', function() {
      header.classList.toggle('scrolled', window.scrollY > topbar.offsetHeight);
    }, { passive: true });
  }

  // ── MEGA MENU: open/close with delay to prevent hover-gap close ──────
  document.querySelectorAll('.be-nav-item--mega').forEach(function(item) {
    var timer;
    item.addEventListener('mouseenter', function() {
      clearTimeout(timer);
      item.classList.add('open');
    });
    item.addEventListener('mouseleave', function() {
      timer = setTimeout(function() {
        item.classList.remove('open');
      }, 120);
    });
  });

  // ── MEGA MENU: sidebar hover switches right panel ──────────────────────
  document.querySelectorAll('.be-mega-panel').forEach(function(panel) {
    var cats    = panel.querySelectorAll('.be-mega-cat');
    var content = panel.querySelectorAll('.be-mega-panel-col');

    cats.forEach(function(cat) {
      cat.addEventListener('mouseenter', function() {
        var idx = cat.dataset.panel;
        cats.forEach(function(c) { c.classList.remove('active'); });
        content.forEach(function(c) { c.classList.remove('active'); });
        cat.classList.add('active');
        var target = panel.querySelector('.be-mega-panel-col[data-panel="' + idx + '"]');
        if (target) target.classList.add('active');
      });
    });
  });

  // ── LANGUAGE SELECTOR ─────────────────────────────────────────────────
  var localeBtn      = document.getElementById('be-locale-btn');
  var localeDropdown = document.getElementById('be-locale-dropdown');
  var localeWrap     = document.getElementById('be-locale-wrap');
  if (localeBtn && localeWrap) {
    localeBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      var open = localeWrap.classList.toggle('open');
      localeBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function() {
      localeWrap.classList.remove('open');
      localeBtn.setAttribute('aria-expanded', 'false');
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && localeWrap.classList.contains('open')) {
        localeWrap.classList.remove('open');
        localeBtn.setAttribute('aria-expanded', 'false');
        localeBtn.focus();
      }
    });
  }

  // ── SEARCH ────────────────────────────────────────────────────────────
  var searchToggle = document.getElementById('be-search-toggle');
  var searchBar    = document.getElementById('be-search-bar');
  var searchClose  = document.getElementById('be-search-close');
  var searchInput  = document.getElementById('be-search-input');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function() {
      var open = searchBar.hidden;
      searchBar.hidden = !open;
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && searchInput) searchInput.focus();
    });
    if (searchClose) searchClose.addEventListener('click', function() {
      searchBar.hidden = true;
      searchToggle.setAttribute('aria-expanded', 'false');
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !searchBar.hidden) {
        searchBar.hidden = true;
        searchToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // ── MOBILE MENU ───────────────────────────────────────────────────────
  var hamburger = document.getElementById('be-hamburger');
  var mobileNav = document.getElementById('be-mobile-nav');
  var overlay   = document.getElementById('be-mobile-overlay');
  var closeBtn  = document.getElementById('be-mobile-close');

  function openMenu()  { mobileNav.classList.add('open'); overlay.classList.add('open'); mobileNav.removeAttribute('aria-hidden'); hamburger.setAttribute('aria-expanded','true'); document.body.style.overflow='hidden'; }
  function closeMenu() { mobileNav.classList.remove('open'); overlay.classList.remove('open'); mobileNav.setAttribute('aria-hidden','true'); hamburger.setAttribute('aria-expanded','false'); document.body.style.overflow=''; }

  if (hamburger) hamburger.addEventListener('click', openMenu);
  if (closeBtn)  closeBtn.addEventListener('click', closeMenu);
  if (overlay)   overlay.addEventListener('click', closeMenu);
  document.addEventListener('keydown', function(e) { if (e.key==='Escape' && mobileNav && mobileNav.classList.contains('open')) closeMenu(); });

  document.querySelectorAll('.be-mobile-trigger[aria-expanded]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var submenu = btn.nextElementSibling;
      var isOpen  = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      submenu.hidden = isOpen;
    });
  });

  // ── CART COUNT ────────────────────────────────────────────────────────
  document.addEventListener('ajaxProduct:added', function() {
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      var badge = document.getElementById('be-cart-badge');
      if (!badge) return;
      badge.textContent = cart.item_count;
      badge.classList.toggle('hidden', cart.item_count === 0);
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["be-keuzehulp"] && !Shopify.designMode) return;
  try {
    
/* ═════════════════════════════════════════════════════════════════════════
   BE Keuzehulp Rozen
   Vragen -> harde filters + rangschikking over de rozen van de collectie.
   De ruwe metaveldwaarden worden hier genormaliseerd (één plek, zie NORM).
   ═════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── Alle zichtbare teksten op één plek (vertaalronde begint hier) ────── */
  var T = {
    stap: 'Stap {n} van {t}',
    kleurCount: { none: 'nog niets gekozen', one: '1 gekozen', many: '{n} gekozen' },
    laden: 'Even onze rozen ophalen…',
    ladenFout: 'We konden de rozen nu niet ophalen. Probeer het zo nog eens.',
    resTitelEen: 'We hebben één roos gevonden die bij jouw tuin past',
    resTitelMeer: 'We hebben {n} rozen gevonden die bij jouw tuin passen',
    resTitelGeen: 'Deze combinatie hebben we niet in de kwekerij staan',
    samenvatting: 'Op basis van: {x}',
    samenvattingLeeg: 'Op basis van je antwoorden',
    relaxTitel: 'We hebben {x} even laten vallen',
    relaxEen: 'Zo houden we één roos over die verder wel bij jouw plek past. Pas een antwoord aan via de knoppen hierboven, of mail ons — we kijken graag mee.',
    relaxMeer: 'Zo houden we {n} rozen over die verder wel bij jouw plek passen. Pas een antwoord aan via de knoppen hierboven, of mail ons — we kijken graag mee.',
    topEen: 'Onze keuze voor jou',
    topMeer: 'Onze top {n} voor jou',
    restLabel: 'Ook geschikt ({n})',
    restLabelDeel: 'Ook geschikt — {n} van de {t} getoond',
    restAlles: 'Bekijk alle rozen in de collectie',
    leegTitel: 'Hier komen we er samen sneller uit',
    leegTekst: 'Ook met ruimere eisen vinden we geen roos voor deze plek. Pas een antwoord aan via de knoppen hierboven, of leg het ons voor — met een foto van de plek weten we het meestal direct.',
    leegMail: 'Mail de kwekerij',
    bekijk: 'Bekijk roos',
    voegToe: '+ Voeg toe',
    toegevoegd: 'Gekozen',
    vanaf: 'vanaf',
    geselecteerd: 'Geselecteerd ({n})',
    rang: ['Onze eerste keuze', 'Sterke tweede', 'Ook een aanrader', 'Goede optie', 'Goede optie', 'Goede optie'],
    leverPot: 'In pot — nu leverbaar',
    leverPotUit: 'In pot tijdelijk uitverkocht — kale wortel vanaf november',
    leverWortel: 'Kale wortel — levering november',
    leverWortelUit: 'Kale wortel tijdelijk niet leverbaar',
    leverBeide: 'In pot: nu leverbaar · kale wortel: november',
    leverGeen: 'Nu niet leverbaar — vraag ons naar de verwachting',
    naarWinkelwagen: 'In winkelwagen zetten…',
    winkelwagenFout: 'Toevoegen lukte niet. Probeer het nog eens.',
    typeNaam: { struik: 'Struikroos', heester: 'Heesterroos', klim: 'Klimroos', rambler: 'Rambler' },
    geurNaam: ['Niet geurend', 'Licht geurend', 'Sterk geurend'],
    laten: { kleur: 'de kleurvoorkeur', hoogte: 'het formaat', grond: 'de grondsoort', zon: 'de zoninschatting' },
    geurType: {
      'old rose': 'klassieke rozengeur', 'damask': 'damascener', 'fruit': 'fruitig',
      'citrus': 'citrus', 'tea': 'theeroos', 'myrrh': 'mirre', 'musk': 'muskus', 'spice': 'kruidig'
    },
    schaduwZin: 'staat volgens onze kwekerij ook in halfschaduw',
    plekZin: {
      border: 'geschikt voor de border', muur: 'geschikt tegen een muur of schutting',
      pergola: 'geschikt voor pergola of rozenboog', haag: 'geschikt als haag of afscheiding',
      los: 'mooi als solitair in de tuin', pot: 'geschikt voor een pot'
    }
  };

  /* ── Voedingsadvies per grondsoort ───────────────────────────────────── */
  var VOEDING = {
    normaal: { k: 'Bij normale tuingrond', v: 'Eén keer bijmesten in het voorjaar is genoeg.', g: 'Geeft de wortels een luchtige start in het plantgat.' },
    droog:   { k: 'Bij vrij droge grond', v: 'Voeding werkt alleen als de grond vocht vasthoudt — geef water na het strooien.', g: 'Houdt vocht vast rond de wortels in droge grond.' },
    klei:    { k: 'Bij zware / kleiachtige grond', v: 'Op klei komt voeding langzaam vrij: meng door de bovenlaag in plaats van erop strooien.', g: 'Meng door de aarde uit het plantgat om zware klei losser te maken.' },
    nat:     { k: 'Bij grond die lang nat blijft', v: 'Wacht met bijmesten tot de grond in het voorjaar is opgedroogd.', g: 'Verbetert de structuur, zodat water sneller wegzakt.' },
    onbekend:{ k: 'Aanbevolen', v: 'Eén keer bijmesten in het voorjaar is voor vrijwel elke tuin genoeg.', g: 'Geeft de wortels een luchtige start in het plantgat.' }
  };

  /* ── Vragen ───────────────────────────────────────────────────────────── */
  var STEPS = ['plek', 'zon', 'hoogte', 'kleur', 'geur', 'grond', 'moment'];
  var MULTI = { kleur: 1 };

  var VRAGEN = {
    plek: {
      titel: 'Waar wil je de roos planten?',
      hint: 'Dit bepaalt of we struikrozen, klimrozen of ramblers voor je zoeken.',
      opts: [
        { v: 'border',  l: 'In een border',                 s: 'Struikrozen en heesterrozen' },
        { v: 'muur',    l: 'Tegen een muur of schutting',   s: 'Klimrozen, geleid langs draden' },
        { v: 'pergola', l: 'Bij een pergola of rozenboog',  s: 'Klimrozen en ramblers' },
        { v: 'haag',    l: 'Als haag of afscheiding',       s: 'Dicht groeiende heesterrozen' },
        { v: 'los',     l: 'Losstaand in de tuin',          s: 'Solitair, van alle kanten zichtbaar' },
        { v: 'pot',     l: 'In een pot op terras of balkon', s: 'Compacte rozen, pot vanaf 40 cm' }
      ]
    },
    zon: {
      titel: 'Hoeveel zon krijgt deze plek in de zomer?',
      hint: 'Kijk naar een gemiddelde zomerdag. Bij minder dan 4 uur vallen rozen af die echt veel zon nodig hebben.',
      klasse: 'bekh-opts--tight', vorm: 'center',
      opts: [
        { v: 'laag', l: 'Minder dan 4 uur', s: 'Schaduwtolerante rozen' },
        { v: 'mid',  l: '4 tot 6 uur',      s: 'Halfschaduw' },
        { v: 'hoog', l: 'Meer dan 6 uur',   s: 'Volle zon' },
        { v: 'onbekend', l: 'Weet ik niet', s: 'We houden het ruim', dashed: true }
      ]
    },
    hoogte: {
      titel: 'Hoe groot mag de roos worden?',
      klasse: 'bekh-opts--tight', vorm: 'center',
      hints: {
        border: 'Denk aan de hoogte na drie jaar, in normale tuingrond.',
        klim: 'Klimrozen en ramblers verschillen sterk in bereik — dit bepaalt welke we adviseren.',
        pot: 'In een pot blijft een roos compacter dan in de volle grond.'
      },
      varianten: {
        border: [
          { v: 'h60', l: 'Tot 60 cm', s: 'Voorste rand' },
          { v: 'h100', l: '60 tot 100 cm', s: 'Meest gekozen' },
          { v: 'h150', l: '100 tot 150 cm', s: 'Achterin de border' },
          { v: 'h150plus', l: 'Hoger dan 150 cm', s: 'Grote heester' }
        ],
        klim: [
          { v: 'm2', l: 'Tot 2 meter', s: 'Lage schutting' },
          { v: 'm3', l: '2 tot 3 meter', s: 'Meest gekozen' },
          { v: 'm5', l: '3 tot 5 meter', s: 'Pergola of gevel' },
          { v: 'm5plus', l: 'Meer dan 5 meter', s: 'Rambler in een boom' }
        ],
        pot: [
          { v: 'p40', l: 'Tot 60 cm', s: 'Pot van 30 tot 40 cm' },
          { v: 'p80', l: '60 tot 100 cm', s: 'Pot van 40 tot 50 cm' },
          { v: 'p120', l: 'Hoger dan 100 cm', s: 'Grote kuip, 60 cm of meer' }
        ]
      }
    },
    kleur: {
      titel: 'Welke kleur of kleuren zoek je?',
      hint: 'Meerdere kleuren mag — {n}',
      klasse: 'bekh-opts--tight',
      opts: [
        { v: 'wit', l: 'Wit of crème', dot: '#fbf8f1' },
        { v: 'geel', l: 'Geel', dot: '#f2d46b' },
        { v: 'abrikoos', l: 'Abrikoos, oranje of zalm', dot: '#f0a868' },
        { v: 'roze', l: 'Roze', dot: '#e48ba8' },
        { v: 'rood', l: 'Rood', dot: '#c0392f' },
        { v: 'paars', l: 'Paars of lila', dot: '#8e6fae' },
        { v: 'alles', l: 'Kleur maakt niet uit', dashed: true }
      ]
    },
    geur: {
      titel: 'Hoe belangrijk is geur voor je?',
      hint: 'Geur bepaalt de volgorde van het advies, niet welke rozen afvallen.',
      klasse: 'bekh-opts--rows',
      opts: [
        { v: 'veel', l: 'Heel belangrijk', s: 'We zetten sterk geurende rozen bovenaan' },
        { v: 'mooi', l: 'Mooi meegenomen', s: 'Geur telt mee, maar is niet doorslaggevend' },
        { v: 'niet', l: 'Niet belangrijk', s: 'We kijken vooral naar plek, formaat en kleur' }
      ]
    },
    grond: {
      titel: 'Hoe is de grond op die plek?',
      hint: 'Grofweg is genoeg — we vragen niet naar pH of grondanalyse. Je antwoord bepaalt welke rozenvoeding we adviseren.',
      klasse: 'bekh-opts--rows',
      opts: [
        { v: 'normaal', l: 'Normale tuingrond' },
        { v: 'droog', l: 'Vrij droge, zanderige grond' },
        { v: 'klei', l: 'Zware of kleiachtige grond' },
        { v: 'nat', l: 'Blijft na regen lang nat' },
        { v: 'onbekend', l: 'Weet ik niet', s: 'We geven dan het algemene advies', dashed: true }
      ]
    },
    moment: {
      titel: 'Wanneer wil je planten?',
      hint: 'Rozen in pot kunnen het hele jaar de grond in. Rozen met kale wortel zijn voordeliger en leveren we in november.',
      klasse: 'bekh-opts--rows',
      opts: [
        { v: 'nu', l: 'Zo snel mogelijk', s: 'We tonen rozen in pot die nu leverbaar zijn' },
        { v: 'najaar', l: 'In het najaar', s: 'Kale wortel, levering in november' },
        { v: 'maakt', l: 'Maakt niet uit', s: 'We laten beide leveringsvormen zien', dashed: true }
      ]
    }
  };

  var LABEL = {
    plek: { border: 'In een border', muur: 'Tegen een muur of schutting', pergola: 'Bij een pergola of rozenboog', haag: 'Als haag of afscheiding', los: 'Losstaand in de tuin', pot: 'In een pot' },
    zon: { laag: 'Minder dan 4 uur zon', mid: '4 tot 6 uur zon', hoog: 'Meer dan 6 uur zon', onbekend: 'Zon onbekend' },
    hoogte: { h60: 'Tot 60 cm', h100: '60 tot 100 cm', h150: '100 tot 150 cm', h150plus: 'Hoger dan 150 cm', m2: 'Tot 2 meter', m3: '2 tot 3 meter', m5: '3 tot 5 meter', m5plus: 'Meer dan 5 meter', p40: 'Tot 60 cm in pot', p80: '60 tot 100 cm in pot', p120: 'Hoger dan 100 cm in pot' },
    kleur: { wit: 'Wit of crème', geel: 'Geel', abrikoos: 'Abrikoos of oranje', roze: 'Roze', rood: 'Rood', paars: 'Paars of lila', alles: 'Kleur maakt niet uit' },
    geur: { veel: 'Geur heel belangrijk', mooi: 'Geur is bonus', niet: 'Geur niet belangrijk' },
    grond: { normaal: 'Normale tuingrond', droog: 'Vrij droge grond', klei: 'Zware of kleiachtige grond', nat: 'Vaak lang natte grond', onbekend: 'Grond onbekend' },
    moment: { nu: 'Planten: zo snel mogelijk', najaar: 'Planten: in het najaar', maakt: 'Plantmoment maakt niet uit' }
  };

  var BANDS = {
    h60: [0, 60], h100: [60, 100], h150: [100, 150], h150plus: [150, 900],
    m2: [0, 200], m3: [200, 300], m5: [300, 500], m5plus: [500, 1500],
    p40: [0, 60], p80: [60, 100], p120: [100, 300]
  };
  var TYPES = {
    border: ['struik', 'heester'], haag: ['heester', 'struik'], los: ['heester', 'struik'],
    muur: ['klim'], pergola: ['klim', 'rambler'], pot: ['struik', 'heester']
  };

  /* ═══ NORMALISATIE ══════════════════════════════════════════════════════
     De enige plek waar ruwe metaveldwaarden worden omgezet. Wijkt de data
     af, dan hoort de aanpassing hier — nergens anders.
     ═══════════════════════════════════════════════════════════════════════ */
  /* De metavelden zijn per taal vertaald en niet overal volledig. De
     herkenning kent daarom de nl/de/fr/en-waarden die in de winkel voorkomen. */
  var KLEURMAP = {
    /* wit */
    wit: 'wit', creme: 'wit', 'crème': 'wit', ivoor: 'wit',
    'weiß': 'wit', weiss: 'wit', blanc: 'wit', white: 'wit', cream: 'wit',
    /* geel */
    geel: 'geel', gelb: 'geel', jaune: 'geel', yellow: 'geel',
    /* abrikoos, oranje, zalm */
    oranje: 'abrikoos', orange: 'abrikoos', abrikoos: 'abrikoos', apricot: 'abrikoos',
    aprikose: 'abrikoos', 'abricot': 'abrikoos', peach: 'abrikoos', pfirsich: 'abrikoos',
    zalm: 'abrikoos', lachs: 'abrikoos', lachsfarben: 'abrikoos', saumon: 'abrikoos', salmon: 'abrikoos',
    brons: 'abrikoos', bronze: 'abrikoos', bruin: 'abrikoos', braun: 'abrikoos',
    brun: 'abrikoos', brown: 'abrikoos', koper: 'abrikoos', kupfer: 'abrikoos',
    /* roze */
    roze: 'roze', rosa: 'roze', rose: 'roze', pink: 'roze',
    cerise: 'roze', cerice: 'roze', serice: 'roze',
    /* rood */
    rood: 'rood', rot: 'rood', rouge: 'rood', red: 'rood',
    zwart: 'rood', schwarz: 'rood', noir: 'rood', black: 'rood', karmijn: 'rood',
    /* paars */
    paars: 'paars', lila: 'paars', violet: 'paars', violett: 'paars', purple: 'paars',
    blauw: 'paars', blau: 'paars', bleu: 'paars', blue: 'paars',
    lavender: 'paars', lavendel: 'paars', lavande: 'paars'
  };

  /* Geur: eerst geurloos, dan middelsterk, dan sterk, dan licht.
     Woordgrenzen, want het Franse "Fort" en het Duitse "Stark" staan vooraan. */
  var GEUR_GEEN   = /geurloos|geen geur|nauwelijks|duftlos|geruchlos|ohne duft|inodore|sans parfum|odou?rless|unscented/;
  var GEUR_MIDDEL = /middel|mittel|moyen|medium/;
  var GEUR_STERK  = /\b(sterk|stark|krachtig|kr(\u00e4|a)ftig|fort|puissant|intens|strong|exception|ausgepr|zeer)/;
  var GEUR_LICHT  = /\b(licht|leicht|l(\u00e9|e)g|light|mild|subti|zacht|discret)|lumi(\u00e8|e)re/;

  function tekst(v) {
    if (v === null || v === undefined) return '';
    if (Array.isArray(v)) return v.join(' | ');
    if (typeof v === 'object') return '';
    return String(v);
  }

  function normHoogte(raw) {
    var s = tekst(raw).replace(/[–—]/g, '-').toLowerCase();
    if (!s) return null;
    var stam = s.indexOf('stam') >= 0;
    var n = (s.match(/\d+/g) || []).map(Number);
    if (!n.length) return null;
    /* Stamrozen: het metaveld noemt de stamhoogte, niet de eindhoogte.
       De kroon komt er nog bovenop — vandaar de marge. */
    if (stam) return [n[0], n[0] + 60];
    if (n.length >= 2 && n[1] > n[0]) return [n[0], n[1]];
    return [n[0], n[0]];
  }

  function normGeur(raw) {
    var s = tekst(raw).toLowerCase();
    if (!s) return 1;
    if (GEUR_GEEN.test(s)) return 0;
    if (GEUR_MIDDEL.test(s)) return 1;
    if (GEUR_STERK.test(s)) return 2;
    if (GEUR_LICHT.test(s)) return 1;
    return 1;
  }

  function normZon(raw) {
    var n = (tekst(raw).match(/\d+/g) || []).map(Number);
    return n.length ? Math.min.apply(null, n) : 6;
  }

  function normKleur(raw) {
    var out = [];
    tekst(raw).toLowerCase().split(/[|,/&]|\s+en\s+|\s+/).forEach(function (p) {
      var k = KLEURMAP[p.trim()];
      if (k && out.indexOf(k) < 0) out.push(k);
    });
    return out;
  }

  /* Een roos kan meer dan één type zijn: 21 Engelse rozen worden zowel als
     grote struikroos als als kleine klimroos verkocht. De collectietag geeft
     het hoofdtype (dat we tonen), de tekstvelden voegen de nevenrollen toe. */
  function normTypes(r) {
    var s = (tekst(r.sub) + ' ' + tekst(r.geb)).toLowerCase();
    var heeft = function () {
      for (var i = 0; i < arguments.length; i++) if (s.indexOf(arguments[i]) >= 0) return true;
      return false;
    };
    var uit = [];
    var voegToe = function (t) { if (t && uit.indexOf(t) < 0) uit.push(t); };
    voegToe(r.t);
    if (heeft('rambler')) voegToe('rambler');
    if (heeft('klimroos', 'klimmer', 'kletterrose', 'climbing rose', 'climber', 'grimpant')) voegToe('klim');
    if (heeft('struikroos', 'strauchrose', 'shrub rose', 'arbuste')) voegToe('struik');
    if (heeft('bodembedekker', 'heesterroos', 'bodendecker', 'ground cover', 'groundcover', 'couvre-sol')) voegToe('heester');
    if (!uit.length) {
      var h = normHoogte(r.h);
      voegToe(h && h[0] >= 200 ? 'klim' : 'struik');
    }
    return uit;
  }

  /* Doorbloeiend: "Ja"/"Nee" en de vertalingen daarvan; sommige producten
     hebben er de bloeiwijze zelf ingezet ("Doorbloeiend" / "Eenmalig bloeiend"). */
  function normDoor(raw) {
    var s = tekst(raw).toLowerCase().trim();
    if (!s) return 0;
    /* Eerst het uitsluitende antwoord: "Nee" en de eenmaalbloeiers. */
    if (/^(nee|nein|non|no)\b/.test(s)) return 0;
    if (/^(niet|nicht|not|pas)\b/.test(s)) return 0;
    if (/eenma|einmal|floraison unique|\bonce\b|non[- ]remont/.test(s)) return 0;
    if (/^(ja|oui|yes)\b/.test(s)) return 1;
    if (/doorbloei|durchbl|dauerbl|\u00f6fterbl|ofterbl|kontinuierlich|continu|remont|repeat|reflower/.test(s)) return 1;
    return 0;
  }

  function normPot(r) {
    var s = tekst(r.pot).toLowerCase().trim();
    if (/^(ja|oui|yes)\b/.test(s)) return true;
    if (/^(nee|nein|non|no)\b/.test(s)) return false;
    return !!r.potTag;
  }

  function verrijk(r) {
    r._types = normTypes(r);
    r._t = r._types[0];
    r._h = normHoogte(r.h) || [0, 900];
    r._g = normGeur(r.g);
    /* _zon is wat de productpagina zegt; _zonMin is wat de winkel met de
       schaduwtag nog aandurft. Alleen die laatste verruimt het filter. */
    r._zon = normZon(r.zon);
    r._zonMin = r.schaduw ? Math.min(r._zon, r.schaduw) : r._zon;
    r._k = normKleur(r.k);
    r._pot = normPot(r);
    r.door = normDoor(r.door);
    /* custom.grondsoort bestaat nog niet in de winkel. Zodra het metaveld
       gevuld is, filtert de grondvraag vanzelf mee. */
    r._grond = tekst(r.grond).toLowerCase().split(/[|,]/).map(function (x) { return x.trim(); }).filter(Boolean);
    return r;
  }

  /* ── Hulpjes ──────────────────────────────────────────────────────────── */
  /* Zelfde prijsopmaak als de rest van de winkel; valt terug op het NL-formaat. */
  function euro(n) {
    var c = Math.round(Number(n) * 100);
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      try { return theme.Currency.formatMoney(c, theme.moneyFormat); } catch (e) { /* val terug */ }
    }
    return '€ ' + Number(n).toFixed(2).replace('.', ',');
  }
  function fmt(s, o) { return String(s).replace(/\{(\w+)\}/g, function (m, k) { return o[k] !== undefined ? o[k] : m; }); }
  function esc(s) {
    return String(s === null || s === undefined ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ═══ De keuzehulp zelf ═════════════════════════════════════════════════ */
  function Keuzehulp(root) {
    this.root = root;
    this.cfg = {
      collectieUrl: root.dataset.collectionUrl,
      top: isNaN(parseInt(root.dataset.top, 10)) ? 3 : parseInt(root.dataset.top, 10),
      rest: isNaN(parseInt(root.dataset.rest, 10)) ? 6 : parseInt(root.dataset.rest, 10),
      badges: root.dataset.badges === '1',
      autoAdvance: root.dataset.autoadvance === '1',
      mail: root.dataset.mail
    };
    this.rozen = null;
    this.laden = null;
    this.q = {
      modal: root.querySelector('[data-bekh-modal]'),
      views: {
        start: root.querySelector('[data-bekh-view="start"]'),
        vragen: root.querySelector('[data-bekh-view="vragen"]'),
        resultaat: root.querySelector('[data-bekh-view="resultaat"]')
      },
      vraag: root.querySelector('[data-bekh-question]'),
      progress: root.querySelector('[data-bekh-progress]'),
      stepcount: root.querySelector('[data-bekh-stepcount]'),
      prev: root.querySelector('[data-bekh-prev]'),
      next: root.querySelector('[data-bekh-next]'),
      nextLabel: root.querySelector('[data-bekh-nextlabel]'),
      skip: root.querySelector('[data-bekh-skip]'),
      resTitle: root.querySelector('[data-bekh-resulttitle]'),
      summary: root.querySelector('[data-bekh-summary]'),
      chips: root.querySelector('[data-bekh-chips]'),
      relax: root.querySelector('[data-bekh-relax]'),
      results: root.querySelector('[data-bekh-results]'),
      selcount: root.querySelector('[data-bekh-selcount]'),
      total: root.querySelector('[data-bekh-total]'),
      cart: root.querySelector('[data-bekh-cart]')
    };
    this.labels = {
      next: root.dataset.nextLabel || 'Volgende',
      result: root.dataset.resultLabel || 'Toon mijn advies',
      add: root.dataset.addLabel || T.voegToe,
      added: root.dataset.addedLabel || T.toegevoegd,
      restart: (root.querySelector('[data-bekh-restart]') || {}).textContent || 'Opnieuw',
      cart: (root.querySelector('[data-bekh-cart]') || {}).textContent || 'Zet alles in de winkelwagen'
    };
    this.labels.cart = String(this.labels.cart).trim();
    this.labels.restart = String(this.labels.restart).trim() || 'Opnieuw';
    this.reset(true);
    this.bind();
  }

  Keuzehulp.instanties = [];
  Keuzehulp.globaalGebonden = false;

  Keuzehulp.prototype.reset = function (stil) {
    this.s = { view: 'closed', step: 0, plek: null, zon: null, hoogte: null, kleur: [], geur: null, grond: null, moment: null, gekozen: {} };
    var lb = this.labels || {};
    this.root.querySelectorAll('[data-bekh-extra]').forEach(function (b) {
      var aan = b.dataset.on === 'true';
      b.classList.toggle('is-on', aan);
      b.dataset.state = aan ? '1' : '0';
      var l = b.querySelector('[data-bekh-addlabel]');
      if (l) l.textContent = aan ? (lb.added || 'Gekozen') : (lb.add || '+ Voeg toe');
    });
    if (!stil) { this.renderVraag(); this.renderResultaat(); this.renderTotaal(); }
  };

  Keuzehulp.prototype.variant = function () {
    var p = this.s.plek;
    if (p === 'muur' || p === 'pergola') return 'klim';
    if (p === 'pot') return 'pot';
    return 'border';
  };

  /* ── Data ─────────────────────────────────────────────────────────────── */
  Keuzehulp.prototype.haalData = function () {
    if (this.laden) return this.laden;
    var basis = this.cfg.collectieUrl.split('?')[0];
    var url = function (p) { return basis + '?view=keuzehulp-data&page=' + p; };
    var self = this;
    this.laden = fetch(url(1), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (eerste) {
        var rest = [];
        for (var p = 2; p <= eerste.pages; p++) {
          rest.push(fetch(url(p)).then(function (r) {
            if (!r.ok) throw new Error('pagina ' + r.url + ': HTTP ' + r.status);
            return r.json();
          }));
        }
        return Promise.all(rest).then(function (delen) {
          var alle = eerste.rozen.slice();
          delen.forEach(function (d) { alle = alle.concat(d.rozen || []); });
          if (eerste.totaal && alle.length < eerste.totaal) {
            console.warn('[BE keuzehulp] ' + alle.length + ' van ' + eerste.totaal + ' rozen opgehaald');
          }
          self.rozen = alle.map(verrijk);
          return self.rozen;
        });
      })
      .catch(function (e) {
        self.laden = null;
        console.error('[BE keuzehulp] data ophalen mislukt', e);
        throw e;
      });
    return this.laden;
  };

  /* ── Filteren en rangschikken ─────────────────────────────────────────── */
  Keuzehulp.prototype.match = function (drop) {
    var s = this.s, d = drop || [];
    var uit = function (k) { return d.indexOf(k) >= 0; };
    var band = (s.hoogte && !uit('hoogte')) ? BANDS[s.hoogte] : null;
    var kleuren = uit('kleur') ? [] : (s.kleur || []).filter(function (c) { return c !== 'alles'; });
    var grondEis = (!uit('grond') && s.grond && s.grond !== 'normaal' && s.grond !== 'onbekend') ? s.grond : null;

    return (this.rozen || []).filter(function (r) {
      if (s.plek === 'pot') {
        if (!r._pot) return false;
        /* Zonder hoogtevraag zou een rambler van tien meter anders in het
           potadvies belanden. */
        if (r._h[0] > 300) return false;
      } else if (s.plek && !TYPES[s.plek].some(function (t) { return r._types.indexOf(t) >= 0; })) {
        return false;
      }
      if (!uit('zon') && s.zon === 'laag' && r._zonMin > 3) return false;
      if (band) {
        if (r._h[1] < band[0] || r._h[0] > band[1]) return false;
        /* Een roos van 100-150 cm hoort niet bij "60 tot 100 cm" alleen omdat
           hij de bandgrens raakt. Rozen met één hoogtewaarde blijven wel mee. */
        if (r._h[0] < r._h[1] && (r._h[1] <= band[0] || r._h[0] >= band[1])) return false;
      }
      if (kleuren.length && !kleuren.some(function (c) { return r._k.indexOf(c) >= 0; })) return false;
      /* Grondsoort filtert alleen mee als het metaveld gevuld is. */
      if (grondEis && r._grond.length && r._grond.indexOf(grondEis) < 0) return false;
      return true;
    });
  };

  /* Bij nul resultaten laten we eisen één voor één vallen, in deze volgorde. */
  Keuzehulp.prototype.resolve = function () {
    var s = this.s, actief = [];
    if ((s.kleur || []).filter(function (c) { return c !== 'alles'; }).length) actief.push('kleur');
    if (s.hoogte) actief.push('hoogte');
    var grondData = (this.rozen || []).some(function (r) { return r._grond.length > 0; });
    if (grondData && s.grond && s.grond !== 'normaal' && s.grond !== 'onbekend') actief.push('grond');
    if (s.zon === 'laag') actief.push('zon');
    var drop = [], lijst = this.match(drop);
    for (var i = 0; i < actief.length && lijst.length === 0; i++) {
      drop.push(actief[i]);
      lijst = this.match(drop);
    }
    return { lijst: lijst, drop: drop };
  };

  Keuzehulp.prototype.score = function (r) {
    var s = this.s, sc = 0;
    if (s.geur === 'veel') sc += r._g * 5;
    else if (s.geur === 'mooi') sc += r._g * 2;
    if (s.zon === 'mid') sc += (r._zonMin <= 4 ? 4 : -3);
    if (r.gez === 'Uitstekend') sc += 2;
    if (r.door) sc += 2;
    if (r.teelt === 'Biologisch geteeld') sc += 1;
    if (s.plek === 'haag') { if (r.haag) sc += 3; else if (r._t === 'heester') sc += 2; }
    if (s.plek === 'pergola' && r._t === 'rambler') sc += 1;
    if (s.plek === 'pot' && r.bodem) sc += 1;
    /* Overlap met de gevraagde hoogteband bepaalt mede de volgorde: een roos
       die er helemaal in past staat boven een die de band net raakt. */
    if (s.hoogte && BANDS[s.hoogte]) {
      var b = BANDS[s.hoogte];
      var midden = (r._h[0] + r._h[1]) / 2;
      if (midden >= b[0] && midden <= b[1]) sc += 4;
      if (r._h[0] === r._h[1]) {
        /* Eén hoogtewaarde heeft geen bereik om mee te overlappen; die zou
           anders structureel drie punten mislopen. */
        sc += (midden >= b[0] && midden <= b[1]) ? 3 : 0;
      } else {
        var overlap = Math.min(r._h[1], b[1]) - Math.max(r._h[0], b[0]);
        sc += Math.round(Math.max(0, overlap) / (r._h[1] - r._h[0]) * 3);
      }
    }
    /* Wie snel wil planten heeft niets aan een advies dat niet leverbaar is. */
    var v = this.leverVariant(r);
    if (s.moment === 'nu' || s.moment === 'najaar') sc += (v && v.op) ? 3 : -4;
    /* Ook zonder plantmoment hoort een roos die helemaal niet leverbaar is
       niet bovenaan het advies te staan. */
    var ietsOpVoorraad = (r.vp && r.vp.op) || (r.vw && r.vw.op);
    if (!ietsOpVoorraad) sc -= 2;
    return sc;
  };

  Keuzehulp.prototype.leverVariant = function (r) {
    var m = this.s.moment;
    /* Bij een gekozen plantmoment telt alleen de bijbehorende leveringsvorm;
       anders zou een kale wortel als 'nu leverbaar' worden aangeboden. */
    if (m === 'najaar') return r.vw || r.vp;
    if (m === 'nu') return (r.vp && r.vp.op) ? r.vp : (r.vp || r.vw);
    if (r.vp && r.vp.op) return r.vp;
    if (r.vw && r.vw.op) return r.vw;
    return r.vp || r.vw;
  };

  Keuzehulp.prototype.leverTekst = function (r) {
    var m = this.s.moment;
    var pot = r.vp, wortel = r.vw;
    if (m === 'nu') {
      if (pot && pot.op) return { t: T.leverPot, oos: false };
      if (wortel && wortel.op) return { t: T.leverPotUit, oos: true };
      return { t: T.leverGeen, oos: true };
    }
    if (m === 'najaar') {
      if (wortel && wortel.op) return { t: T.leverWortel, oos: false };
      if (pot && pot.op) return { t: T.leverWortelUit, oos: true };
      return { t: T.leverGeen, oos: true };
    }
    if (pot && pot.op && wortel && wortel.op) return { t: T.leverBeide, oos: false };
    if (pot && pot.op) return { t: T.leverPot, oos: false };
    if (wortel && wortel.op) return { t: T.leverWortel, oos: false };
    return { t: T.leverGeen, oos: true };
  };

  /* Bij een gekozen plantmoment tonen we de prijs van díé leveringsvorm; pas
     zonder keuze is het een vanaf-prijs. */
  Keuzehulp.prototype.prijs = function (r) {
    var m = this.s.moment;
    if (m === 'nu' || m === 'najaar') {
      var v = this.leverVariant(r);
      if (v) return { bedrag: v.p, vanaf: false };
    }
    /* Alleen wat te bestellen is telt mee; anders adverteren we een prijs die
       de klant niet kan afrekenen. */
    var prijzen = [];
    if (r.vp && r.vp.op) prijzen.push(r.vp.p);
    if (r.vw && r.vw.op) prijzen.push(r.vw.p);
    if (!prijzen.length) {
      if (r.vp) prijzen.push(r.vp.p);
      if (r.vw) prijzen.push(r.vw.p);
    }
    if (!prijzen.length) prijzen.push(r.p);
    var laag = Math.min.apply(null, prijzen);
    return { bedrag: laag, vanaf: prijzen.length > 1 && Math.max.apply(null, prijzen) > laag };
  };

  Keuzehulp.prototype.waarom = function (r) {
    var s = this.s, bits = [];
    bits.push(T.typeNaam[r._t] + (r._h[0] === r._h[1] ? ' van ' + r._h[0] + ' cm' : ' van ' + r._h[0] + ' tot ' + r._h[1] + ' cm'));
    if (s.plek) bits.push(T.plekZin[s.plek]);
    /* Of het metaveld zelf al weinig zon vraagt, of de kwekerij hem via de
       schaduwtag toch aandurft — nooit allebei, dat leest als tegenspraak. */
    if (s.zon === 'laag' || s.zon === 'mid') {
      var grens = s.zon === 'laag' ? 3 : 4;
      if (r._zon <= grens) bits.push('heeft aan ' + r._zon + ' uur zon genoeg');
      else if (r._zonMin <= grens) bits.push(T.schaduwZin);
    }
    if (s.geur === 'veel' && r._g === 2) {
      var gt = T.geurType[tekst(r.gt).toLowerCase()];
      bits.push(gt ? 'sterke geur (' + gt + ')' : 'sterke geur');
    }
    if (r.bijen) bits.push('geliefd bij bijen en vlinders');
    if (r.gez === 'Uitstekend') bits.push('uitstekend gezond blad');
    if (s.plek === 'haag' && r.haag) bits.push('door ons aangeraden voor rozenhagen');
    if (r.snij && (s.plek === 'border' || s.plek === 'los')) bits.push('ook mooi als snijroos');
    var t = bits.join(' · ');
    return t.charAt(0).toUpperCase() + t.slice(1) + '.';
  };

  Keuzehulp.prototype.facetten = function (r) {
    return [
      { i: 'be-icon-height', t: r._h[0] === r._h[1] ? r._h[0] + ' cm' : r._h[0] + '–' + r._h[1] + ' cm' },
      { i: 'be-icon-scent', t: T.geurNaam[r._g] },
      { i: 'be-icon-sun', t: 'Min. ' + r._zon + ' uur zon' },
      { i: 'be-icon-repeat', t: r.door ? 'Doorbloeiend' : 'Eenmaal bloeiend' }
    ];
  };

  /* ── Vraagscherm tekenen ──────────────────────────────────────────────── */
  Keuzehulp.prototype.opties = function (key) {
    var def = VRAGEN[key];
    if (key === 'hoogte') return def.varianten[this.variant()];
    return def.opts;
  };

  Keuzehulp.prototype.hint = function (key) {
    var def = VRAGEN[key];
    if (key === 'hoogte') return def.hints[this.variant()];
    if (key === 'kleur') {
      var n = (this.s.kleur || []).filter(function (c) { return c !== 'alles'; }).length;
      var tel = n === 0 ? T.kleurCount.none : (n === 1 ? T.kleurCount.one : fmt(T.kleurCount.many, { n: n }));
      return fmt(def.hint, { n: tel });
    }
    return def.hint || '';
  };

  Keuzehulp.prototype.renderVraag = function () {
    var key = STEPS[this.s.step], def = VRAGEN[key], self = this;
    var waarde = this.s[key];
    var opts = this.opties(key);

    var html = '<div class="bekh-q__head"><h2 class="bekh-q__title">' + esc(def.titel) + '</h2>';
    var hint = this.hint(key);
    if (hint) html += '<p class="bekh-q__hint">' + esc(hint) + '</p>';
    html += '</div><div class="bekh-opts ' + (def.klasse || '') + '" role="group">';

    opts.forEach(function (o) {
      var aan = MULTI[key] ? (waarde || []).indexOf(o.v) >= 0 : waarde === o.v;
      var vorm = def.vorm === 'center' ? ' bekh-opt--center' : (o.s && !o.dot ? ' bekh-opt--stack' : '');
      html += '<button type="button" class="bekh-opt' + vorm + (o.dashed ? ' bekh-opt--dashed' : '') + (aan ? ' is-on' : '') +
        '" data-val="' + esc(o.v) + '" aria-pressed="' + (aan ? 'true' : 'false') + '">';
      if (o.dot) html += '<span class="bekh-opt__dot" style="background:' + esc(o.dot) + '"></span>';
      html += '<span class="bekh-opt__label">' + esc(o.l) + '</span>';
      if (o.s) html += '<span class="bekh-opt__sub">' + esc(o.s) + '</span>';
      html += '</button>';
    });
    html += '</div>';

    this.q.vraag.innerHTML = html;
    this.q.vraag.querySelectorAll('.bekh-opt').forEach(function (b) {
      b.addEventListener('click', function () { self.kies(key, b.dataset.val); });
    });

    this.q.stepcount.textContent = fmt(T.stap, { n: this.s.step + 1, t: STEPS.length });
    this.q.progress.innerHTML = STEPS.map(function (_, i) {
      return '<span class="' + (i <= self.s.step ? 'is-done' : '') + '"></span>';
    }).join('');
    this.q.prev.disabled = this.s.step === 0;
    this.q.prev.style.visibility = this.s.step === 0 ? 'hidden' : '';
    var laatste = this.s.step === STEPS.length - 1;
    this.q.nextLabel.textContent = laatste ? this.labels.result : this.labels.next;
    this.q.vraag.scrollTop = 0;
    var eersteOptie = this.q.vraag.querySelector('.bekh-opt');
    if (eersteOptie && this.s.view === 'vragen') eersteOptie.focus();
  };

  /* Zolang het paneel zich als dialoog aandient, hoort Tab er ook in te blijven. */
  Keuzehulp.prototype.houdFocusVast = function (e) {
    var paneel = this.q.views[this.s.view];
    if (!paneel) return;
    var velden = paneel.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!velden.length) return;
    var eerste = velden[0], laatste = velden[velden.length - 1];
    if (e.shiftKey && document.activeElement === eerste) { e.preventDefault(); laatste.focus(); }
    else if (!e.shiftKey && document.activeElement === laatste) { e.preventDefault(); eerste.focus(); }
    else if (!paneel.contains(document.activeElement)) { e.preventDefault(); eerste.focus(); }
  };

  Keuzehulp.prototype.kies = function (key, val) {
    var s = this.s;
    if (MULTI[key]) {
      var lijst = (s[key] || []).slice();
      if (val === 'alles') {
        s[key] = lijst.indexOf('alles') >= 0 ? [] : ['alles'];
      } else {
        var i = lijst.indexOf(val);
        if (i >= 0) lijst.splice(i, 1); else lijst.push(val);
        s[key] = lijst.filter(function (x) { return x !== 'alles'; });
      }
      this.renderVraag();
      return;
    }
    var nieuw = s[key] === val ? null : val;
    s[key] = nieuw;
    if (key === 'plek') s.hoogte = null;
    this.renderVraag();
    if (this.cfg.autoAdvance && nieuw) {
      var self = this;
      clearTimeout(this._autoTimer);
      this._autoTimer = setTimeout(function () {
        if (self.s.view === 'vragen') self.volgende();
      }, 140);
    }
  };

  Keuzehulp.prototype.ga = function (n) {
    this.s.step = Math.max(0, Math.min(STEPS.length - 1, n));
    this.toon('vragen');
    this.renderVraag();
  };
  Keuzehulp.prototype.volgende = function () {
    if (this.s.step >= STEPS.length - 1) this.toonResultaat();
    else this.ga(this.s.step + 1);
  };
  Keuzehulp.prototype.vorige = function () { this.ga(this.s.step - 1); };
  Keuzehulp.prototype.sla = function () {
    var k = STEPS[this.s.step];
    this.s[k] = MULTI[k] ? [] : null;
    if (k === 'plek') this.s.hoogte = null;
    this.volgende();
  };

  /* ── Resultaatscherm tekenen ──────────────────────────────────────────── */
  Keuzehulp.prototype.toonResultaat = function () {
    var self = this;
    this.toon('resultaat');
    if (this.rozen) { this.renderResultaat(); return; }
    this.q.results.innerHTML = '<div class="bekh-loading"><svg class="bekh-ico" aria-hidden="true"><use href="#be-icon-repeat"></use></svg>' + esc(T.laden) + '</div>';
    this.q.resTitle.textContent = '';
    this.haalData().then(function () { self.renderResultaat(); })
      .catch(function () { self.q.results.innerHTML = '<p class="bekh-empty__text">' + esc(T.ladenFout) + '</p>'; });
  };

  Keuzehulp.prototype.renderResultaat = function () {
    if (!this.rozen) return;
    var self = this, s = this.s;
    var res = this.resolve();
    var gesorteerd = res.lijst.slice().sort(function (a, b) {
      return self.score(b) - self.score(a) || a.p - b.p;
    });
    /* Veertien rassen staan twee keer in de collectie (duplicaat of XL-versie).
       Alleen de best scorende hoort in het advies. */
    var gezien = {};
    gesorteerd = gesorteerd.filter(function (r) {
      var sleutel = (r.n || '').trim().toLowerCase();
      if (!sleutel) return true;
      if (gezien[sleutel]) return false;
      gezien[sleutel] = true;
      return true;
    });
    this.gesorteerd = gesorteerd;

    /* Kop en samenvatting */
    this.q.resTitle.textContent = gesorteerd.length === 0
      ? T.resTitelGeen
      : (gesorteerd.length === 1 ? T.resTitelEen : fmt(T.resTitelMeer, { n: gesorteerd.length }));

    var sum = [];
    if (s.plek) sum.push(LABEL.plek[s.plek].toLowerCase());
    if (s.zon && s.zon !== 'onbekend') sum.push(LABEL.zon[s.zon].toLowerCase());
    if (s.hoogte) sum.push(LABEL.hoogte[s.hoogte].toLowerCase());
    if (s.moment === 'nu') sum.push('rozen in pot');
    else if (s.moment === 'najaar') sum.push('kale wortel in november');
    this.q.summary.textContent = sum.length ? fmt(T.samenvatting, { x: sum.join(' · ') }) : T.samenvattingLeeg;

    /* Antwoordknoppen om terug te springen */
    var chips = [];
    STEPS.forEach(function (k, i) {
      var v = s[k];
      if (MULTI[k]) (v || []).forEach(function (x) { chips.push({ l: LABEL[k][x], i: i }); });
      else if (v) chips.push({ l: LABEL[k][v], i: i });
    });
    this.q.chips.innerHTML = chips.map(function (c) {
      return '<button type="button" class="bekh-chip" data-step="' + c.i + '">' + esc(c.l) +
        '<svg class="bekh-ico" aria-hidden="true"><use href="#be-icon-wrench"></use></svg></button>';
    }).join('');
    this.q.chips.querySelectorAll('.bekh-chip').forEach(function (b) {
      b.addEventListener('click', function () { self.ga(parseInt(b.dataset.step, 10)); });
    });

    /* Melding als er eisen zijn losgelaten */
    if (res.drop.length && gesorteerd.length) {
      var namen = res.drop.map(function (k) { return T.laten[k] || k; });
      var lijstTekst = namen.length > 1 ? namen.slice(0, -1).join(', ') + ' en ' + namen[namen.length - 1] : namen[0];
      this.q.relax.innerHTML =
        '<span class="bekh-relax__title">' + esc(fmt(T.relaxTitel, { x: lijstTekst })) + '</span>' +
        '<span class="bekh-relax__text">' + esc(gesorteerd.length === 1 ? T.relaxEen : fmt(T.relaxMeer, { n: gesorteerd.length })) + '</span>';
      this.q.relax.hidden = false;
    } else {
      this.q.relax.hidden = true;
    }

    /* Kaarten */
    var top = gesorteerd.slice(0, this.cfg.top);
    var rest = gesorteerd.slice(this.cfg.top, this.cfg.top + this.cfg.rest);
    var html = '';

    if (top.length) {
      html += '<div class="bekh-cards"><span class="bekh-sublabel">' +
        esc(top.length === 1 ? T.topEen : fmt(T.topMeer, { n: top.length })) + '</span>';
      top.forEach(function (r, i) { html += self.kaart(r, i); });
      html += '</div>';
    } else {
      html += '<div class="bekh-empty">' +
        '<h3 class="bekh-empty__title">' + esc(T.leegTitel) + '</h3>' +
        '<p class="bekh-empty__text">' + esc(T.leegTekst) + '</p>' +
        '<div class="bekh-empty__actions">' +
        '<button type="button" class="bekh-btn bekh-btn--ghost" data-bekh-restart>' + esc(self.labels.restart) + '</button>' +
        '<a class="bekh-btn bekh-btn--ghost" href="mailto:' + esc(this.cfg.mail) + '?subject=Hulp%20bij%20rozenkeuze">' + esc(T.leegMail) + '</a>' +
        '</div></div>';
    }

    if (rest.length) {
      var restTotaal = gesorteerd.length - top.length;
      var restKop = rest.length < restTotaal
        ? fmt(T.restLabelDeel, { n: rest.length, t: restTotaal })
        : fmt(T.restLabel, { n: restTotaal });
      html += '<div class="bekh-rest"><span class="bekh-sublabel">' + esc(restKop) + '</span>' +
        '<div class="bekh-rest__grid">';
      rest.forEach(function (r) {
        html += '<a class="bekh-rest__item" href="' + esc(r.url || ('/products/' + r.u)) + '">' +
          (r.i ? '<img src="' + esc(r.i) + '" alt="" loading="lazy" width="46" height="54">' : '') +
          '<span class="bekh-rest__txt"><span class="bekh-rest__name">' + esc(r.n) + '</span>' +
          '<span class="bekh-rest__meta">' + esc(T.typeNaam[r._t] + ' · ' + r._h[0] + '–' + r._h[1] + ' cm · ' + T.geurNaam[r._g].toLowerCase()) + '</span></span>' +
          '<span class="bekh-rest__price">' + esc(euro(self.prijs(r).bedrag)) + '</span></a>';
      });
      html += '</div><a class="bekh-rest__all" href="' + esc(this.cfg.collectieUrl) + '">' + esc(T.restAlles) + '</a></div>';
    }

    this.q.results.innerHTML = html;
    this.q.results.querySelectorAll('[data-bekh-kies]').forEach(function (b) {
      b.addEventListener('click', function () {
        var h = b.dataset.bekhKies;
        self.s.gekozen[h] = !self.s.gekozen[h];
        b.classList.toggle('is-on', !!self.s.gekozen[h]);
        b.querySelector('[data-bekh-addlabel]').textContent = self.s.gekozen[h] ? self.labels.added : self.labels.add;
        self.renderTotaal();
      });
    });
    var opnieuw = this.q.results.querySelector('[data-bekh-restart]');
    if (opnieuw) opnieuw.addEventListener('click', function () { self.opnieuw(); });

    this.pasVoedingsadviesAan();
    this.renderTotaal();
  };

  Keuzehulp.prototype.kaart = function (r, i) {
    var lever = this.leverTekst(r);
    var variant = this.leverVariant(r);
    var gekozen = !!this.s.gekozen[r.u];
    var prijs = this.prijs(r);
    var badges = '<span class="bekh-badge bekh-badge--rank">' + esc(T.rang[i] || T.rang[T.rang.length - 1]) + '</span>';
    if (this.cfg.badges && r.teelt) {
      var bio = r.teelt === 'Biologisch geteeld';
      badges += '<span class="bekh-badge' + (bio ? ' bekh-badge--bio' : '') + '">' + esc(r.teelt) + '</span>';
    }

    return '<article class="bekh-card bekh-card--top">' +
      '<a href="' + esc(r.url || ('/products/' + r.u)) + '">' +
        (r.i ? '<img class="bekh-card__img" src="' + esc(r.i) + '" alt="' + esc(r.n) + '" loading="lazy" width="130" height="150">' : '<span class="bekh-card__img"></span>') +
      '</a>' +
      '<div class="bekh-card__body">' +
        '<div class="bekh-card__tags">' + badges + '</div>' +
        '<h3 class="bekh-card__name">' + esc(r.n) + '</h3>' +
        '<div class="bekh-card__facets">' + this.facetten(r).map(function (f) {
          return '<span><svg class="bekh-ico" aria-hidden="true"><use href="#' + f.i + '"></use></svg>' + esc(f.t) + '</span>';
        }).join('') + '</div>' +
        '<p class="bekh-card__why">' + esc(this.waarom(r)) + '</p>' +
        '<span class="bekh-card__lever' + (lever.oos ? ' is-oos' : '') + '"><span class="bekh-dot"></span>' + esc(lever.t) + '</span>' +
      '</div>' +
      '<div class="bekh-card__buy">' +
        '<span class="bekh-card__price">' + (prijs.vanaf ? '<small>' + esc(T.vanaf) + '</small>' : '') + esc(euro(prijs.bedrag)) + '</span>' +
        (variant && variant.op
          ? '<button type="button" class="bekh-btn bekh-btn--add' + (gekozen ? ' is-on' : '') + '" data-bekh-kies="' + esc(r.u) + '"><span data-bekh-addlabel>' + esc(gekozen ? this.labels.added : this.labels.add) + '</span></button>'
          : '') +
        '<a class="bekh-linkbtn bekh-linkbtn--arrow" href="' + esc(r.url || ('/products/' + r.u)) + '">' + esc(T.bekijk) +
          '<svg class="bekh-ico" aria-hidden="true"><use href="#be-icon-chevron-right"></use></svg></a>' +
      '</div></article>';
  };

  /* De grondvraag stuurt het bovenschrift en de tekst bij de extra's. */
  Keuzehulp.prototype.pasVoedingsadviesAan = function () {
    var v = VOEDING[this.s.grond || 'onbekend'] || VOEDING.onbekend;
    this.root.querySelectorAll('[data-bekh-kicker]').forEach(function (elm) {
      var rol = elm.dataset.bekhKicker;
      elm.textContent = (rol === 'voeding' || rol === 'grond') ? v.k : (elm.dataset.fallback || '');
    });
    this.root.querySelectorAll('[data-bekh-why]').forEach(function (elm) {
      var rol = elm.dataset.bekhWhy;
      elm.textContent = rol === 'voeding' ? v.v : (rol === 'grond' ? v.g : (elm.dataset.fallback || ''));
    });
  };

  /* ── Selectie en winkelwagen ──────────────────────────────────────────── */
  Keuzehulp.prototype.selectie = function () {
    var self = this, items = [];
    /* Alleen de getoonde top heeft een knop; een roos die daaruit zakt mag niet
       stilzwijgend in de winkelwagen blijven staan. */
    (this.gesorteerd || []).slice(0, this.cfg.top).forEach(function (r) {
      if (!self.s.gekozen[r.u]) return;
      var v = self.leverVariant(r);
      if (v && v.op) items.push({ id: v.id, prijs: v.p });
    });
    this.root.querySelectorAll('[data-bekh-extra]').forEach(function (b) {
      if (b.dataset.state === '1') items.push({ id: parseInt(b.dataset.bekhExtra, 10), prijs: parseInt(b.dataset.price, 10) / 100 });
    });
    return items;
  };

  Keuzehulp.prototype.renderTotaal = function () {
    var items = this.selectie();
    var som = items.reduce(function (t, i) { return t + i.prijs; }, 0);
    this.q.selcount.textContent = fmt(T.geselecteerd, { n: items.length });
    this.q.total.textContent = items.length ? euro(som) : '—';
    this.q.cart.disabled = items.length === 0;
  };

  Keuzehulp.prototype.naarWinkelwagen = function () {
    var self = this, items = this.selectie();
    if (!items.length) return;
    var knop = this.q.cart, oud = this.labels.cart;
    knop.disabled = true;
    knop.textContent = T.naarWinkelwagen;
    var url = (window.theme && theme.routes && theme.routes.cartAdd) ? theme.routes.cartAdd : '/cart/add.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items.map(function (i) { return { id: i.id, quantity: 1 }; }) })
    })
      .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'cart'); }); return r.json(); })
      .then(function () {
        knop.textContent = oud;
        knop.disabled = false;
        self.sluit();
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      })
      .catch(function (e) {
        console.error('[BE keuzehulp] winkelwagen', e);
        knop.textContent = T.winkelwagenFout;
        setTimeout(function () { knop.textContent = oud; knop.disabled = false; }, 2600);
      });
  };

  /* ── Openen, sluiten, navigeren ───────────────────────────────────────── */
  Keuzehulp.prototype.toon = function (view) {
    this.s.view = view;
    var v = this.q.views;
    Object.keys(v).forEach(function (k) { if (v[k]) v[k].hidden = k !== view; });
    this.q.modal.hidden = false;
    document.body.classList.add('bekh-locked');
    var paneel = v[view];
    if (paneel && !paneel.contains(document.activeElement)) {
      var eerste = paneel.querySelector('button, a[href]');
      if (eerste) eerste.focus();
    }
  };

  Keuzehulp.prototype.open = function () {
    this.haalData().catch(function () {});
    this.toon('start');
    this.vorigeFocus = document.activeElement;
    var eerste = this.q.views.start.querySelector('[data-bekh-begin]');
    if (eerste) eerste.focus();
  };

  Keuzehulp.prototype.sluit = function () {
    clearTimeout(this._autoTimer);
    this.s.view = 'closed';
    this.q.modal.hidden = true;
    document.body.classList.remove('bekh-locked');
    if (this.vorigeFocus && this.vorigeFocus.focus) this.vorigeFocus.focus();
  };

  Keuzehulp.prototype.opnieuw = function () {
    this.reset(true);
    this.toon('start');
    this.pasVoedingsadviesAan();
    this.renderTotaal();
  };

  Keuzehulp.prototype.bind = function () {
    var self = this;
    this.root.querySelectorAll('[data-bekh-close]').forEach(function (b) {
      b.addEventListener('click', function () { self.sluit(); });
    });
    var begin = this.root.querySelector('[data-bekh-begin]');
    if (begin) begin.addEventListener('click', function () { self.ga(0); });
    this.q.prev.addEventListener('click', function () { self.vorige(); });
    this.q.next.addEventListener('click', function () { self.volgende(); });
    this.q.skip.addEventListener('click', function () { self.sla(); });
    this.q.cart.addEventListener('click', function () { self.naarWinkelwagen(); });
    this.root.querySelectorAll('[data-bekh-restart]').forEach(function (b) {
      b.addEventListener('click', function () { self.opnieuw(); });
    });
    this.root.querySelectorAll('[data-bekh-extra]').forEach(function (b) {
      b.addEventListener('click', function () {
        var aan = b.dataset.state !== '1';
        b.dataset.state = aan ? '1' : '0';
        b.classList.toggle('is-on', aan);
        b.querySelector('[data-bekh-addlabel]').textContent = aan ? self.labels.added : self.labels.add;
        self.renderTotaal();
      });
    });
    /* Documentbrede listeners horen bij de pagina, niet bij de sectie: bij een
       herlaadbeurt in de theme-editor zouden ze zich anders opstapelen. */
    Keuzehulp.instanties.push(this);
    if (!Keuzehulp.globaalGebonden) {
      Keuzehulp.globaalGebonden = true;
      document.addEventListener('keydown', function (e) {
        var k = Keuzehulp.instanties.filter(function (x) { return x.s.view !== 'closed'; })[0];
        if (!k) return;
        if (e.key === 'Escape') { k.sluit(); return; }
        if (e.key !== 'Tab') return;
        k.houdFocusVast(e);
      });
      /* Elke knop of link met data-bekh-open opent de keuzehulp — ook buiten
         deze sectie, zodat hij later vanuit menu of PDP aangeroepen kan worden. */
      document.addEventListener('click', function (e) {
        var t = e.target.closest ? e.target.closest('[data-bekh-open]') : null;
        if (!t) return;
        e.preventDefault();
        var eigen = t.closest('[data-bekh]');
        var k = (eigen && eigen.bekh) || Keuzehulp.instanties[0];
        if (k) k.open();
      });
    }
    if (window.location.hash === '#keuzehulp') this.open();
  };

  /* ── Starten ──────────────────────────────────────────────────────────── */
  function start() {
    document.querySelectorAll('[data-bekh]').forEach(function (root) {
      if (root.dataset.bekhKlaar === '1') return;
      root.dataset.bekhKlaar = '1';
      try {
        var k = new Keuzehulp(root);
        root.bekh = k;
        k.pasVoedingsadviesAan();
        k.renderTotaal();
      } catch (e) {
        console.error('[BE keuzehulp] init mislukt', e);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["be-main-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('product-form:cart:navigate', function(event) {
  if (window.theme && theme.settings && theme.settings.cartType !== 'page') {
    event.preventDefault();
  }
});
document.addEventListener('product-form:submit:success', function() {
  document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
});
document.addEventListener('product-form:submit:error', function(event) {
  var btn = document.getElementById('be-btn-cart');
  if (!btn) return;
  var originalHTML = btn.innerHTML;
  var msg = (event.detail && event.detail.error && event.detail.error.description)
    ? event.detail.error.description
    : (btn.dataset.labelError || 'Niet beschikbaar');
  btn.innerHTML = '<svg class="be-icon be-icon--md" style="stroke:#fff"><use href="#be-icon-x"/></svg> ' + msg;
  btn.style.background = '#b91c1c';
  setTimeout(function() {
    btn.innerHTML = originalHTML;
    btn.style.background = '';
  }, 3000);
});

// Meldingspil op een variantkaart (terugkeer kale wortel / levering pot) — tap/klik opent de tooltip
(function() {
  var wraps = Array.prototype.slice.call(document.querySelectorAll('.be-variant-oos'));
  if (!wraps.length) return;

  function closeAll(except) {
    wraps.forEach(function(wrap) {
      if (wrap === except) return;
      wrap.classList.remove('open');
      var pill = wrap.querySelector('button.be-variant-oos__pill');
      if (pill) pill.setAttribute('aria-expanded', 'false');
    });
  }

  wraps.forEach(function(wrap) {
    var pill = wrap.querySelector('button.be-variant-oos__pill');
    var tip  = wrap.querySelector('.be-variant-oos__tip');
    if (!pill) return;

    pill.addEventListener('click', function(event) {
      // De kaart eromheen heeft een eigen onclick die de variant selecteert
      event.preventDefault();
      event.stopPropagation();
      closeAll(wrap);
      var open = wrap.classList.toggle('open');
      pill.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    // Klik op de opengeklapte tekst mag de variant niet selecteren of sluiten
    if (tip) tip.addEventListener('click', function(event) { event.stopPropagation(); });
  });

  document.addEventListener('click', function() { closeAll(null); });
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') closeAll(null);
  });
})();

// Sticky ATC bar — show after user scrolls past the main ATC button
(function() {
  var stickyBar = document.getElementById('be-sticky-atc');
  var mainBtn   = document.getElementById('be-btn-cart');
  if (!stickyBar || !mainBtn) return;

  function updateStickyVisibility() {
    var rect = mainBtn.getBoundingClientRect();
    var pastBtn = rect.bottom < 0;
    stickyBar.classList.toggle('be-sticky-atc--visible', pastBtn);
    stickyBar.setAttribute('aria-hidden', pastBtn ? 'false' : 'true');
  }

  window.addEventListener('scroll', updateStickyVisibility, { passive: true });
  updateStickyVisibility();

  // Keep sticky price + state in sync when variant changes
  var origSelectVariant = window.beSelectVariant;
  window.beSelectVariant = function(el, price, priceFormatted, variantId, available) {
    if (origSelectVariant) origSelectVariant(el, price, priceFormatted, variantId, available);
    var stickyPrice = document.getElementById('be-sticky-price');
    var stickyBtn   = document.getElementById('be-sticky-btn');
    if (stickyPrice) stickyPrice.textContent = priceFormatted;
    if (stickyBtn) {
      stickyBtn.disabled = !available;
      stickyBtn.classList.toggle('be-btn-cart--oos', !available);
      stickyBtn.querySelector('use').setAttribute('href', available ? '#be-icon-cart' : '#be-icon-x');
      stickyBtn.lastChild.textContent = available
        ? (stickyBtn.dataset.labelAdd || 'Toevoegen')
        : (stickyBtn.dataset.labelOos || 'Uitverkocht');
    }
  };
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["be-product-simple"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('product-form:cart:navigate', function(event) {
  if (window.theme && theme.settings && theme.settings.cartType !== 'page') {
    event.preventDefault();
  }
});
document.addEventListener('product-form:submit:success', function() {
  document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
});
document.addEventListener('product-form:submit:error', function(event) {
  var btn = document.getElementById('be-btn-cart');
  if (!btn) return;
  var originalHTML = btn.innerHTML;
  var msg = (event.detail && event.detail.error && event.detail.error.description)
    ? event.detail.error.description
    : (btn.dataset.labelError || 'Niet beschikbaar');
  btn.innerHTML = '<svg class="be-icon be-icon--md" style="stroke:#fff"><use href="#be-icon-x"/></svg> ' + msg;
  btn.style.background = '#b91c1c';
  setTimeout(function() {
    btn.innerHTML = originalHTML;
    btn.style.background = '';
  }, 3000);
});

// Pill variant selection — update compare-at price display
(function() {
  document.querySelectorAll('.be-pill').forEach(function(pill) {
    pill.addEventListener('click', function() {
      document.querySelectorAll('.be-pill').forEach(function(p) { p.classList.remove('selected'); });
      pill.classList.add('selected');
      var compareEl = document.getElementById('be-display-compare');
      var compareMobile = document.querySelector('.be-mobile-price-block .be-price-compare');
      var compareVal = pill.dataset.compare;
      var price = pill.dataset.price;
      if (compareEl) {
        compareEl.style.display = (compareVal && parseInt(compareVal) > parseInt(price)) ? '' : 'none';
      }
      if (compareMobile) {
        compareMobile.style.display = (compareVal && parseInt(compareVal) > parseInt(price)) ? '' : 'none';
      }
    });
  });
})();

// Sticky ATC bar
(function() {
  var stickyBar = document.getElementById('be-sticky-atc');
  var mainBtn   = document.getElementById('be-btn-cart');
  if (!stickyBar || !mainBtn) return;

  function updateStickyVisibility() {
    var rect = mainBtn.getBoundingClientRect();
    var pastBtn = rect.bottom < 0;
    stickyBar.classList.toggle('be-sticky-atc--visible', pastBtn);
    stickyBar.setAttribute('aria-hidden', pastBtn ? 'false' : 'true');
  }

  window.addEventListener('scroll', updateStickyVisibility, { passive: true });
  updateStickyVisibility();

  var origSelectVariant = window.beSelectVariant;
  window.beSelectVariant = function(el, price, priceFormatted, variantId, available) {
    if (origSelectVariant) origSelectVariant(el, price, priceFormatted, variantId, available);
    var stickyPrice = document.getElementById('be-sticky-price');
    var stickyBtn   = document.getElementById('be-sticky-btn');
    if (stickyPrice) stickyPrice.textContent = priceFormatted;
    if (stickyBtn) {
      stickyBtn.disabled = !available;
      stickyBtn.classList.toggle('be-btn-cart--oos', !available);
      stickyBtn.querySelector('use').setAttribute('href', available ? '#be-icon-cart' : '#be-icon-x');
      stickyBtn.lastChild.textContent = available
        ? (stickyBtn.dataset.labelAdd || 'Toevoegen')
        : (stickyBtn.dataset.labelOos || 'Uitverkocht');
    }
  };
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
